import { render } from "./FilterCollapse.vue?vue&type=template&id=b8ce36e6&scoped=true"
import script from "./FilterCollapse.vue?vue&type=script&lang=js"
export * from "./FilterCollapse.vue?vue&type=script&lang=js"

import "./FilterCollapse.vue?vue&type=style&index=0&id=b8ce36e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8ce36e6"]])

export default __exports__